let BadgeRanking = {
    adding: false,
    fetching: false,
    refreshing: false,

    add: function () {
        if (!BadgeRanking.adding) {
            BadgeRanking.adding = true;
            let btn_create = document.getElementById("add_habbo");
            let box_container = document.getElementById(
                "create_ranking_top_box"
            );
            btn_create.disabled = true;
            Api.post("/badgesranking/add", {}, function (r) {
                if (r.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "¡Tu habbo ha sido añadido exitosamente al ranking de placas! A coleccionar.",
                            icon: "circle-check",
                        },
                    ]);
                    box_container.remove();
                } else {
                    btn_create.disabled = false;
                    switch (r.error.identifier) {
                        case "habbo_verified/mandatory":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Debes verificar tu Habbo para poder añadirlo al ranking de placas.",
                                    icon: "circle-check",
                                },
                            ]);
                            break;
                        case "habbo_already_created":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Tu habbo ya se encuentra inscrito en el ranking de placas.",
                                    icon: "circle-check",
                                },
                            ]);
                            box_container.remove();
                            break;
                        case "habbo_profile_invisible/error":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Tu perfil está oculto, necesitas colocarlo visible para el cálculo y creación del ranking.",
                                    icon: "circle-check",
                                },
                            ]);
                            break;
                        case "internal_error":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Hay unos cables que se han estropeado. Intentalo de nuevo.",
                                    icon: "circle-check",
                                },
                            ]);
                            break;
                        case "service/unavailable":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Hemos deshabilitado temporalmente la adición de nuevos habbos. Intentalo en unos minutos.",
                                    icon: "circle-check",
                                },
                            ]);
                            break;
                    }
                }
            });
            BadgeRanking.adding = false;
        }
    },

    search: function () {
        if (!BadgeRanking.fetching) {
            BadgeRanking.fetching = true;
            let container = document.getElementById("habbo_search_container");
            let search_habbo = document.getElementById("search_habbo_name");
            Api.get(
                "/badgesranking/search",
                { habbo: search_habbo.value },
                function (r) {
                    if (r.success) {
                        let template = `
                        <div class="box box-big">
                            <div class="body" style="display:flex;align-items: center;">
                                <img src="https://www.habbo.es/habbo-imaging/avatarimage?user=${
                                    r.habbo
                                }&direction=2&head_direction=3&gesture=sml&action=wav&size=n" alt="Habbo">
                                <div class="badgeranking_container">
                                    <h1 class="font-weight-bold">${r.habbo}</h1>
                                    <div class="badgeranking_badge_data_container">
                                        <div class="badgeranking_total_badges">Total: ${
                                            r.statistics.current
                                        }</div>
                                        <div class="badgeranking_variation_badges ${
                                            r.statistics.variation > 0
                                                ? "up"
                                                : "stable"
                                        }">Variación: ${
                            r.statistics.variation
                        }</div>
                                    </div>
                                    <div class="badgeranking_status">
                                        ${
                                            r.status === "9"
                                                ? "Este Habbo ha sido excluído en la última actualización de estadísticas."
                                                : "Disponible en el ranking."
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                        container.innerHTML = template;
                    } else {
                        switch (r.error.identifier) {
                            case "habbo_not_found":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! El usuario consultado no existe en el ranking.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                container.innerHTML = "";
                                break;
                        }
                    }
                }
            );
            BadgeRanking.fetching = false;
        }
    },
    getTop: function (page) {
        if (!BadgeRanking.refreshing) {
            BadgeRanking.refreshing = true;
            let type = document.getElementById("type_search").value;
            let endpoint = `/badgesranking/${type}`;
            let btn = document.getElementById("search");
            let content = document.getElementById("ranking_data");
            let pagination = document.getElementById("pagination");
            content.innerHTML = "";
            btn.disabled = true;
            Api.get(endpoint, { page }, function (r) {
                if (r.success) {
                    r.data.map((row) => {
                        let template = `
                            <tr style="align-items: center;">
                                <td>${row.position}</td>
                                <td><img src="https://www.habbo.es/habbo-imaging/avatarimage?user=${row.habbo}&direction=3&head_direction=3&gesture=sml&img_format=png&headonly=1&action=wav" alt="${row.habbo}"></td>
                                <td>${row.habbo}</td>
                                <td>${row.statistics.current}</td>
                                <td>${row.statistics.variation}</td>
                            </tr>
                       `;
                        content.insertAdjacentHTML("beforeend", template);
                    });
                } else {
                    switch (r.error.identifier) {
                    }
                }
            });
            btn.disabled = false;
            BadgeRanking.refreshing = false;
        }
    },
    initTopByPage: function (page, type) {
        if (!BadgeRanking.refreshing) {
            BadgeRanking.refreshing = true;
            let type_ranking = type === "leaders" ? "leaders" : "hunters";
            let endpoint = `/badgesranking/${type}?page=${page}`;
            let btn = document.getElementById("search");
            let content = document.getElementById("ranking_data");
            let pagination = document.getElementById("pagination");
            content.innerHTML = "";
            btn.disabled = true;
            Api.get(endpoint, {}, function (r) {
                if (r.success) {
                    r.data.map((row) => {
                        let template = `
                            <tr style="align-items: center;">
                                <td>${row.position}</td>
                                <td><img src="https://www.habbo.es/habbo-imaging/avatarimage?user=${row.habbo}&direction=3&head_direction=3&gesture=sml&img_format=png&headonly=1&action=wav" alt="${row.habbo}"></td>
                                <td>${row.habbo}</td>
                                <td>${row.statistics.current}</td>
                                <td>${row.statistics.variation}</td>
                            </tr>
                       `;
                        content.insertAdjacentHTML("beforeend", template);
                    });

                    let prev = "";
                    let next = "";

                    if (r.pagination.current_page > 1) {
                        prev = `
                            <div class="button-group">
                                <a href="/extras/ranking/${type_ranking}/1" class="button orange"><i
                                    class="glyphicons glyphicons-rewind"></i></a>
                                <a href="/extras/ranking/${type_ranking}/${r.pagination.prev_page}" class="button orange"><i
                                    class="glyphicons glyphicons-arrow-left"></i></a>
                            </div>
                        `;
                    }

                    if (r.pagination.current_page < r.pagination.last_page) {
                        next = `
                            <div class="button-group">
                                <a href="/extras/ranking/${type_ranking}/${r.pagination.next_page}"class="button orange"><i class="glyphicons glyphicons-arrow-right"></i></a>
                                <a href="/extras/ranking/${type_ranking}/${r.pagination.last_page}" class="button orange"><i class="glyphicons glyphicons-forward"></i></a>
                            </div>
                        `;
                    }

                    let template_pagination = `
                         <div class="body">
                            <div class="d-flex justify-content-between" style="margin: 5px">
                                ${prev}
                                ${next}
                            </div>
                        </div>
                    `;
                    pagination.innerHTML = template_pagination;
                } else {
                }
            });
            btn.disabled = false;
            BadgeRanking.refreshing = false;
        }
    },
};
